<p-table
  [value]="summaryData()"
  rowHover="true"
  [responsiveLayout]="'stack'"
  [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
>
  <ng-template #header>
    <tr>
      <th pSortableColumn="workItemName" style="width: 55%">
        Nazwa
        <p-sortIcon field="workItemName" />
      </th>
      <th pSortableColumn="totalDuration" style="width: 15%">
        Czas
        <p-sortIcon field="totalDuration" />
      </th>
      <th pSortableColumn="totalRevenue" style="width: 30%" class="text-right">
        Wynagrodzenie
        <p-sortIcon field="totalRevenue" />
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td data-label="Nazwa">
        <div class="flex items-center">
          <span
            class="w-1 self-stretch rounded me-3 flex-shrink-0"
            [style.background-color]="item.color || 'var(--app-border)'"
            [title]="'Kolor: ' + (item.color || 'brak')"
          ></span>

          <div class="flex items-center gap-1">
            @if(isOwner()) {
              <span *ngIf="item.workItemName" class="font-medium">
                <a
                  [routerLink]="['/work-items', item.workItemId]"
                  class="hover:underline text-primary-600 dark:text-primary-300"
                >
                  {{ item.workItemName }}
                </a>
              </span>
            } @else {
              <span *ngIf="item.workItemName" class="font-medium">
                {{ item.workItemName }}
              </span>
            }

            <span *ngIf="!item.workItemName" class="font-medium">
              {{ item.clientName }}
            </span>

            <small *ngIf="item.workItemName" class="text-gray-500 dark:text-gray-400">
              {{ item.clientName ? ' - ' + item.clientName : '' }}
            </small>
          </div>
        </div>
      </td>
      <td data-label="Czas">{{ item.totalDuration | minutesToHours: 'long' }}</td>
      <td data-label="Wynagrodzenie" class="text-right">
        <div class="inline-flex w-full flex-col items-end gap-0.5">
          <span class="block font-semibold text-[var(--app-text)] whitespace-nowrap">
            {{ item.totalRevenue | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL' }}
          </span>
          @if (item.billingMode === 'REVENUE_THRESHOLD') {
            <span class="block text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
              Kwota wpisów: {{ item.totalGrossRevenue | currency: 'PLN' : 'symbol' : '1.2-2' : 'pl-PL' }}
            </span>
          }
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3" class="text-center">
        <div class="flex flex-row items-center justify-center gap-3 py-5">
          <i class="pi pi-info-circle text-4xl text-gray-400 dark:text-gray-500"></i>
          <span class="app-muted font-medium">Brak danych do wyświetlenia.</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
